import { CompositeFilterDescriptor, FilterDescriptor, isCompositeFilterDescriptor, State } from "@progress/kendo-data-query";
import { t } from "i18next";

export interface FieldStats {
	sum: number;
	min: number;
	max: number;
	average: number;
}

export function calculateFieldStats(data: any[], field: string): FieldStats {
	let sum = 0;
	let min = Number.POSITIVE_INFINITY;
	let max = Number.NEGATIVE_INFINITY;
	let count = 0;

	for (const item of data) {
		const rawValue = item[field];
		if (rawValue == null) continue;
		const value = Number(rawValue);
		if (isNaN(value)) continue;
		sum += value;
		if (value < min) min = value;
		if (value > max) max = value;
		count++;
	}

	return {
		sum,
		min: count > 0 ? min : 0,
		max: count > 0 ? max : 0,
		average: count > 0 ? sum / count : 0,
	};
}

export const handleGroupEmptyMessage = (dataState: State) => {
	if (dataState.group) {
		return;
	}
	const container = document.querySelector(".k-grouping-drop-container");
	if (container) {
		try {
		
			if (
				container.firstChild &&
				container.firstChild.nodeType === Node.TEXT_NODE
			) {
				container.firstChild.textContent = t("GroupEmptyMessage");
			} else {
				const textNode = document.createTextNode(t("GroupEmptyMessage"));
				while (container.firstChild) {
					container.removeChild(container.firstChild);
				}
				container.appendChild(textNode);
			}
		} catch (err) {
			console.error("Failed to update group message:", err);
		}
	}
};


export const isColumnFiltered = (field: string, filters: CompositeFilterDescriptor): boolean => {
	return filters.filters.some((f) => {
		if(isCompositeFilterDescriptor(f)) {
			return isColumnFiltered(field, f as CompositeFilterDescriptor);
		}
		 return (f as FilterDescriptor).field === field;
	});
}

export const handleFilteredItem = (
    filters: CompositeFilterDescriptor
): { field: string; values: any[] }[] => {
    const clonedFilters: CompositeFilterDescriptor = JSON.parse(JSON.stringify(filters));
    const result: { field: string; values: any[] }[] = [];

    const processFilter = (filter: FilterDescriptor | CompositeFilterDescriptor) => {
        if (isCompositeFilterDescriptor(filter)) {
            (filter as CompositeFilterDescriptor).filters.forEach((f) => processFilter(f));
        } else {
            const singleFilter: FilterDescriptor = { ...filter } as FilterDescriptor;
            
            if (!singleFilter.field || typeof singleFilter.field !== "string") {
                return;
            }
            const existingItem = result.find((r) => r.field === singleFilter.field);
            if (existingItem) {
                existingItem.values.push(singleFilter.value);
            } else {
                result.push({ field: singleFilter.field, values: [singleFilter.value] });
            }
        }
    };

    clonedFilters.filters.forEach((f) => processFilter(f));
    return result;
};